import { orderVinculationSessionsDetailAction } from '_models/redux/order_vinculation_sessions_details/action';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import CustomDialog from 'widgets/component/CustomDialog';
import SessionSection from './SessionSection';

const VinculationSessions = ({ sessions, transactionId, setIsSessionModalOpen }) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [localSessionDetail, setLocalSessionDetail] = useState(null);
  const sessionRedux = useSelector((state) => state.orderVinculationSessionsDetail);
  const sessionDetail = sessionRedux?.response;
  const Label = ({ children }) => (
    <span style={{ color: '#422b4c', fontWeight: 'bold' }}>{children}</span>
  );
  // Si solo hay una sesión, mostrar el detalle automáticamente SOLO si openModal está en false
  useEffect(() => {
    if (sessions && sessions?.length === 1 && !openModal) {
      const session = sessions[0];
      setModalLoading(true);
      setOpenModal(true);
      if (setIsSessionModalOpen) setIsSessionModalOpen(true);
      dispatch(orderVinculationSessionsDetailAction(transactionId, session.interview_id)).finally(
        () => {
          setModalLoading(false);
        },
      );
    }
  }, [sessions, transactionId, setIsSessionModalOpen, dispatch, openModal]);

  const handleShowSessionDetails = (session) => {
    if (sessions.length === 1) return;
    setLocalSessionDetail(null);
    setModalLoading(true);
    setOpenModal(true);
    if (setIsSessionModalOpen) setIsSessionModalOpen(true);
    dispatch(orderVinculationSessionsDetailAction(transactionId, session?.interview_id)).finally(
      () => {
        setModalLoading(false);
      },
    );
  };

  useEffect(() => {
    if (openModal && sessionDetail && Object.keys(sessionDetail).length > 0) {
      setLocalSessionDetail(sessionDetail);
    }
    // Si no hay datos y el modal está abierto, limpiar para evitar mostrar datos viejos
    if (openModal && (!sessionDetail || Object.keys(sessionDetail).length === 0)) {
      setLocalSessionDetail(null);
    }
  }, [sessionDetail, openModal]);

  const handleCloseModal = () => {
    setOpenModal(false);
    if (setIsSessionModalOpen) setIsSessionModalOpen(false);
    setLocalSessionDetail(null);
  };
  return (
    <>
      {/* Si hay más de una sesión, mostrar el listado. Si solo hay una, no mostrar el listado */}
      {sessions.length > 1 && (
        <SessionSection sessions={sessions} handleShowSessionDetails={handleShowSessionDetails} />
      )}
      {openModal && (
        <CustomDialog
          open={openModal}
          onClose={handleCloseModal}
          title={'Detalle de Sesión'}
          maxWidth='sm'
          fullWidth
          content={
            modalLoading ? (
              <p style={{ textAlign: 'center', fontSize: 16 }}>Cargando...</p>
            ) : localSessionDetail && localSessionDetail?.title && localSessionDetail?.detail ? (
              <div style={{ textAlign: 'center', color: 'red' }}>
                <b>{localSessionDetail.title}</b>
                <div>{localSessionDetail.detail}</div>
              </div>
            ) : localSessionDetail ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div>
                  <Label>Fecha de creación:</Label>{' '}
                  <span>{convertToMexicoTime(localSessionDetail.created || 'N/A')}</span>
                </div>
                <div>
                  <Label>Pasaporte:</Label>{' '}
                  <span style={{ wordBreak: 'break-all' }}>
                    {localSessionDetail.passport_number || 'N/A'}
                  </span>
                </div>
                <div>
                  <Label>CURP:</Label>{' '}
                  <span style={{ wordBreak: 'break-all' }}>
                    {localSessionDetail?.curp || 'N/A'}
                  </span>
                </div>
                <div>
                  <Label>Calificación:</Label>{' '}
                  <span>{localSessionDetail?.global_score || 'N/A'}</span>
                </div>
                <div>
                  <Label>Tipo de usuario:</Label>{' '}
                  <span>
                    {localSessionDetail?.is_company === true
                      ? 'Persona moral'
                      : localSessionDetail?.is_company === false
                        ? 'Persona física'
                        : 'N/A'}
                  </span>
                </div>
                <div>
                  <Label>Nombre:</Label>{' '}
                  <span style={{ wordBreak: 'break-all' }}>
                    {localSessionDetail?.legal_name || 'N/A'}
                  </span>
                </div>
                <div>
                  <Label>Nacionalidad:</Label>{' '}
                  <span>{localSessionDetail?.nationality || 'N/A'}</span>
                </div>
                <div>
                  <Label>Fecha de vinculación:</Label>{' '}
                  <span>{convertToMexicoTime(localSessionDetail?.linked_date || 'N/A')}</span>
                </div>
                <div>
                  <Label>Legal ID:</Label>{' '}
                  <span style={{ wordBreak: 'break-all' }}>
                    {localSessionDetail?.legal_id || 'N/A'}
                  </span>
                </div>
                <div>
                  <Label>Última actualización:</Label>{' '}
                  <span>{convertToMexicoTime(localSessionDetail?.updated || 'N/A')}</span>
                </div>

                {localSessionDetail?.error_details?.error_details?.length > 0 && (
                  <div style={{ marginTop: 8 }}>
                    <b>Errores:</b>
                    <ul style={{ paddingLeft: 18, fontSize: 14 }}>
                      {localSessionDetail.error_details.error_details.map((err, i) => (
                        <li key={i} style={{ marginBottom: 4 }}>
                          <b>{err.description}</b>
                          <ul style={{ paddingLeft: 16 }}>
                            {err.details.map((d, j) => (
                              <li key={j}>{d}</li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ) : (
              <p style={{ textAlign: 'center' }}>No hay información.</p>
            )
          }
          extraButtons={[
            {
              label: 'Cerrar',
              variant: 'contained',
              onClick: handleCloseModal,
              buttonColor: '#6a1b9a',
              textColor: '#fff',
            },
          ]}
        />
      )}
    </>
  );
};

export default VinculationSessions;
